import { ContactPage } from "@/features/contact/pages/Contact";

const Contact = () => {
  return <ContactPage />;
};

export default Contact;
